(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_0e81fda"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sc-dragon-top')) {
  customElements.define('sc-dragon-top', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('.sc-dragon-top__button');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        event.stopPropagation();
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        for (let node = this.parentElement; node; node = node.parentElement) {
          if (node.scrollTop > 0) node.scrollTo({ top: 0, behavior });
        }
        window.scrollTo({ top: 0, left: 0, behavior });
      }, true);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
